import React from "react";
import email from './email.png';
import './MotivationLetter.css';

class MotivationLetter extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">الموتفيشن ليتر <img alt='' src={email} width='50' height='50' /></legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        Motivation letter أزاي تكتب
                                        <br/>
                                        الخطاب التحفيزي أختصارا يعتبر من اهم الاوراق المطلوبة للسفارة .. هو بالظبط زي خطاب لشخص مرشح لمنصب ما لما بيطلع يخطب ... قبل ماتكتب الخطاب ده لازم تعرف انه سلاح ذو حدين يعني زي ما ممكن يكون سبب في قبولك فممكن يكون سبب فى رفضك
                                        <br/>
                                        يعنى لازم تفهم ايه اللى هتكتبه و بتكتب ايه 
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        = ايه فايدة الموتفيشن ليتر
                                        <br/>
                                        فايدته ان لما اللى بيراجع ورقك و بيقرر هتتقبل والا لا فبيقرأ الخطاب دة وبيعرف ايه دوافعك و عايز تعمل ايه و انت مين 
                                        <br/>
                                        اذا كان هتقدمه للجامعة او للسفارة 
                                        <br/>
                                        = فقرات الموتفيشن ليتر
                                        <br/>
                                        انا شخصيا لما كتبت الموتفيشن ليتر وانا بقدمه للسفارة فكتبته مختلف عن اللى قدمته للجامعة لان الخطاب المقدم للسفارة فيه ترتيب اكتر و فيه فقرات اكتر من الموتفيشن اللى هتقدمه للجامعة
                                        <br/>
                                        = الخطاب المقدم للسفارة 
                                        <br/>
                                        لازم يحتوى على الفقرات دى
                                        <br/>
                                        1- تعريف عن النفس 
                                        <br/>
                                        2- ليه التخصص اللى هتقدم عليه
                                        <br/>
                                        3- ليه المانيا
                                        <br/>
                                        4- ليه الجامعة دى 
                                        <br/>
                                        5- ليه المدينة 
                                        <br/>
                                        6- لو هتسافر تدرس لغة فيفضل تكتب نبذة عن خطة اللغة 
                                        <br/>
                                        7- ايه احلامك فى المستقبل 
                                        <br/>
                                        لازم تركز فى النقط دى لان الكلام دة هيعرفوا من خلالها شخصيتك وممكن يسألوك فيها
                                        <br/>
                                        - اما الخطاب المقدم للجامعة
                                        <br/>
                                        بتبقا نفس الفقرات او ممكن اقل و ممكن تلاقى على موقع الجامعة كاتبين محتوى الموتفيشن ليتر اللى هما عايزينه " فيه جامعات بتطلب الموتفيشن ليتر و جامعات لا " 
                                        ...
                                        <br/>
                                        = نقط مهمة لازم تاخد بالك منها.
                                        <br/>
                                        - مش لازم اللى هتقدمه للجامعة تقدمه للسفارة لان السفارة مش هتراجع الورق اللى انت قدمته للجامعة 
                                        <br/>
                                        - حاول مترغيش كتير و تكون واضح فى كلامك 
                                        <br/>
                                        - حاول متزيدش عن صفحتين و اكتب بخط يكون واضح و فونت 11 كويس
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        = نماذج للموتفيشن ليتر و خطاب التوصية للشباب اللى عايزة تعرف ازاى بيتكتبوا
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://youtu.be/jrinZqPdodA'>فيديو أ/محمد شحاتة</a> بيشرح فيه يعنى ايه الموتفيشن ليتر
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.file-upload.com/t4ta0k44n863'>دة لينك فيه نماذج للموتفيشن</a>
                                        <br/>
                                        = الموتفيشن انت اللى بتكتبه و مبيتوثقش سفارة والا اى حاجة
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://drive.google.com/file/d/0B8ybbTCmN9sfTmUxTERTNWpuZ28/view'>ملف من منظمة الداد</a> عن الموتفيشن ليتر و طريقة الكتابة
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        دة لينك فيه نماذج لخطاب التوصية
                                        <br/>
                                        التوصية بتروح للدكتور فى الجامعة او معيد او اى حد درسلك فى الجامعة حتى لو العميد او رئيس القسم   و بتقوله عايز خطاب توصية  و دة فيما معناه ان هو بيكتب كلمتين كويسين عنك ان انك مجتهد و بتساعد غيرك و شاطر و الحوارات دى و فى الاخر بيكتب  الاميل بتاعه و تليفونه و بيمضى ومش لازم ختم الجامعة او المعهد  ومش لازم تتوثق كمان الا لو الجامعة عايزاه متوثق
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.file-upload.com/chn3j3cjmptu'>Part 1</a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/.../permalink/502881240090601/'>نموذج لخطاب التوصية ايضا</a>
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        موقعين اونلاين بتقدر تعمل من خلالهم CV
                                        <br/>
                                        و مبيتوثقش
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='http://europass.cedefop.europa.eu/documents/curriculum-vitae'>europass.cedefop.europa.eu</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://lebenslauf.com/'>lebenslauf.com</a>
                                        </div>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default MotivationLetter;
